export const savingData = {
  namespaced: true,

  state: () => ({
    pagesData: {} // { [pageKey]: { scrollPositions: number, ...otherData } }
  }),

  getters: {
    getPageData: (state) => (pageKey) => {
      return state.pagesData[pageKey] || null
    },
    getScrollPosition: (state) => (pageKey) => {
      return state.pagesData[pageKey]?.scrollPosition || 0
    }
  },

  actions: {
    savePageData({ state, commit }, { pageKey, data }) {
      commit('SET_PAGE_DATA', { pageKey, data })
    },

    saveScrollPosition({ commit }, { pageKey, position }) {
      commit('SET_SCROLL_POSITION', { pageKey, position })
    },

    clearPageData({ commit }, pageKey) {
      commit('CLEAR_PAGE_DATA', pageKey)
    },

    clearAllPageData({ commit }, { exclude, including } = {}) {
      commit('CLEAR_ALL_PAGE_DATA', { exclude, including })
    }
  },

  mutations: {
    SET_PAGE_DATA(state, { pageKey, data }) {
      state.pagesData[pageKey] = {
        ...(state.pagesData[pageKey] || {}),
        ...data,
      }
    },

    SET_SCROLL_POSITION(state, { pageKey, position }) {
      if (!state.pagesData[pageKey]) {
        state.pagesData[pageKey] = {}
      }
      state.pagesData[pageKey].scrollPosition = position
    },

    CLEAR_PAGE_DATA(state, pageKey) {
      if (state.pagesData[pageKey]) {
        const newData = { ...state.pagesData }
        delete newData[pageKey]
        state.pagesData = newData
      }
    },

    CLEAR_ALL_PAGE_DATA(state, params = {}) {
      // todo: exclude, including
      const {exclude, including} = params

      const excludeData = {}

      if(exclude && exclude.length) {
        exclude.forEach(key => excludeData[key] = state.pagesData[key])
      }

      state.pagesData = {
        ...excludeData,
        // Home: state.pagesData.Home
      }
    }
  }
}
